import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import SourceContext from 'helpers/SourceContext';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';
import NameYourData from './NameYourData';

import { CHOOSE_SOURCE_TYPE_URL } from 'pages/Directory/consts';

function Container() {
  const sourceContext = useContext(SourceContext);
  const history = useHistory();
  const { sourceInfo } = sourceContext;

  const directoryIdUrlMatch = window.location.href.match(/directories\/.*\/create-source/);
  const directoryId = directoryIdUrlMatch ? directoryIdUrlMatch[0].split('/')[1] : undefined;
  const baseUrl = makeSourceCreateBaseUrl(directoryId);

  if (!sourceInfo.type) {
    history.push(`${baseUrl}${CHOOSE_SOURCE_TYPE_URL}`);
  }

  return <NameYourData />;
}

export default Container;
